import { AxiosResponse } from 'axios';

const pad = (num: number): string => num.toString().padStart(2, '0');

export const exportDataBlobFromResponse = ( 
        response: AxiosResponse<Blob>,
        typeOfDownload : string,
        fallbackFileName: string = 'export.csv',
                ): string => {
  
    const blob = new Blob([response.data], { type: response.data.type });

  // Try to extract file name from Content-Disposition header
  // const currentTimestamp = new Date().toISOString().replace(/[:.]/g, '-');
  // const contentDisposition = response.headers['content-disposition'];
  // const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
  // const baseFileName = fileNameMatch ? fileNameMatch[1].replace(/\.csv$/i, '') : 'export';
  // const fileName = `${baseFileName}_${currentTimestamp}.csv`;
  const now = new Date();
  const formattedTimestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}-${now.getMilliseconds()}`;

  // Final file name: typeOfDownload_YYYY-MM-DD-HH-MM-SS-sss.csv
  const fileName = `${typeOfDownload}_${formattedTimestamp}.csv`;

  // Create object URL and trigger download
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return fileName;

};

  export const exportXlsxFromResponse = (
    response: AxiosResponse<Blob>,
    typeOfDownload: string,
    fallbackFileName: string = "export.xlsx"
  ): string => {
    // Ensure blob uses correct MIME type
    const blob = new Blob([response.data], {
      type: response.data.type ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Build timestamp
    const now = new Date();
    const formattedTimestamp = `${pad(now.getMonth() + 1
    )}-${pad(now.getDate())}-${now.getFullYear()}-${pad(now.getHours())}-${pad(
      now.getMinutes()
    )}-${pad(now.getSeconds())}-${now.getMilliseconds()}`;

    // File name
    const fileName = `${typeOfDownload}_${formattedTimestamp}.xlsx`;

    // Trigger download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return fileName;
  };